import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-logs',
  templateUrl: './logs.component.html'
})
export class LogsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
